// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"df8dade6","453":"d3ecfcf7","732":"5e5b4355"}[chunkId] + ".chunk.js";
};